import type { Health } from './primitives.js'

export interface HealthInput {
  valor: number | null
  direccion: 'higher_better' | 'lower_better'
  /** Alcanzarlo o superarlo (según dirección) es estar en target. */
  umbralOk: number | null
  /** Frontera entre atención y crítico. null = sin frontera crítica. */
  umbralWarning: number | null
}

/**
 * Decide el color del semáforo de una métrica.
 *
 * `unknown` cuando no hay dato o no hay benchmark: la UI lo muestra como
 * "sin dato" con acción de carga, nunca como cero.
 */
export function evaluateHealth({
  valor,
  direccion,
  umbralOk,
  umbralWarning,
}: HealthInput): Health {
  if (valor === null) return 'unknown'
  if (umbralOk === null && umbralWarning === null) return 'unknown'

  const meets = (umbral: number) =>
    direccion === 'higher_better' ? valor >= umbral : valor <= umbral

  if (umbralOk !== null && meets(umbralOk)) return 'ok'
  if (umbralWarning === null) return 'warning'
  return meets(umbralWarning) ? 'warning' : 'critical'
}
